/**
 * Created by Victor Rojo on 28/2/19.
 */
import {Component, Input, OnDestroy, ViewChild, ElementRef, AfterContentInit, HostListener} from '@angular/core';
import {CameraWidget} from "../../widget/Widget";
import {WidgetStatusChangeAware} from "../base-widget/WidgetStatusChangeAware";
import {IPlaceDataChangeService} from "../../IPlaceDataChange.service";

@Component({
  selector: 'camera',
  templateUrl: './Camera.component.html',
  styleUrls: ['./Camera.component.css']
})
export class CameraComponent extends WidgetStatusChangeAware{


  src = "";
  _camera: CameraWidget;
  isLoading = true;
  attemp = 1;
  isFullscreen = false;
  selected:any = null;
  @ViewChild('image', { static: true }) image: ElementRef;

  private retryTimeout:any;

  constructor(private iPlaceDataChangeService1: IPlaceDataChangeService) {
    super(iPlaceDataChangeService1);
  }

  get camera(): CameraWidget {
    return this._camera;
  }

  @Input()
  set camera(camera: CameraWidget) {
    this._camera = camera;
    this.updateStreamingList();
  }

  private updateStreamingList() {
    this.src = "";
    if ( this._camera.cameras && this._camera.cameras.length ) {
      this.selectStreaming(this._camera.cameras[0]);

    }
  }

  selectStreaming(camera:any) {
    this.isLoading = true;
    this.attemp = 1;
    this.image.nativeElement.src = "";
    this.image.nativeElement.src = this.src;
    this.src = "api/v1/camera/" + camera.cameraId + "/streaming";
    this.selected = camera;
    this.retryIfNotLoaded();
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
    if ( this.isFullscreen ) {
      this.setFullscreen(false);
    }
  }

  retryIfNotLoaded() {
    if ( this.retryTimeout != null ) {
      clearTimeout(this.retryTimeout);
      this.retryTimeout = null;
    }
    this.retryTimeout = setTimeout(()=>{
      this.retryTimeout = null;
      if ( this.isLoading && this.attemp < 5) {
        this.image.nativeElement.src = "";
        this.image.nativeElement.src = this.src;
        this.attemp++;
        console.log("Attemp retry " + this.attemp );
        this.retryIfNotLoaded();
      } else if ( this.attemp >= 3 ) {
        this.isLoading = false;
      }
    }, 5000);
  }

  loaded($event): void {
    console.log($event);
    this.isLoading = false;
  }

  setFullscreen(value:boolean){
    this.isFullscreen = value;
  }

  snapshot(){
    var c = document.createElement('canvas');

    c.width = this.image.nativeElement.width;
    c.height = this.image.nativeElement.height;
    var ctx = c.getContext('2d');

    ctx.drawImage(this.image.nativeElement, 0, 0);

    //var image = c.toDataURL("image/png").replace("image/png", "image/octet-stream");  // here is the most important part because if you dont replace you will get a DOM 18 exception.
    //window.location.href=image;

    var link = document.createElement('a');
    link.setAttribute('download', this.selected.name + new Date().toLocaleString() + '.png');
    link.setAttribute('href', c.toDataURL("image/png").replace("image/png", "image/octet-stream"));
    link.click();
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
    this.image.nativeElement.src = "";
    this.src = "";
  }
}
